module.exports = __webpack_public_path__ + "static/media/pizza-2.27780258.jpg";